import { createContext } from "react";
export interface AppContextProps {
    isMobileView: boolean;
    setLoader: (show: boolean) => void;
    navigate: (hash: string) => void;
    updatePageReference: (params: { hash: string, ref: any }) => void;
}

export const AppContext = createContext<AppContextProps | undefined>(undefined)